import styled, { css } from 'styled-components';
import { media, layout, colorUtils } from '@prisjakt/ui-base';

export const ExpandButton = styled.div(
  props => css`
    display: flex;
    justify-content: center;
    align-items: center;
    transition: background-color ${layout.animations.buttonTransition};
    background-color: ${props.theme.bg.secondary};
    border-radius: 4px;
    width: 30px;
    height: 30px;
    color: ${props.theme.text.secondary};

    svg path {
      fill: ${props.theme.icons.secondary};
    }

    ${media.smallOnly`
    background-color: transparent;
  `}
  `
);

export const ExpandWrapper = styled.button(
  props => css`
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    outline: none;
    cursor: pointer;
    min-height: 100%;
    &:hover ${ExpandButton} {
      background-color: ${colorUtils.shadeColor(props.theme.bg.secondary, -20)};

      ${media.smallOnly`
      background-color: transparent;
    `}
    }
  `
);
